import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-10",
  "use": "menu-10-usage",
  "viewBox": "0 0 69.47 69.46",
  "content": "<symbol viewBox=\"0 0 69.47 69.46\" id=\"menu-10\"><title>资源 106</title><g id=\"menu-10_图层_2\" data-name=\"图层 2\"><g id=\"menu-10_图层_1-2\" data-name=\"图层 1\"><path d=\"M64.6,4.86a16.63,16.63,0,0,0-23.49,0L23.71,22.26a16.61,16.61,0,0,0-4.4,15.62L13.7,32.27,4.86,41.11A16.61,16.61,0,1,0,28.34,64.6L45.75,47.2a16.5,16.5,0,0,0,4.87-11.74,16.7,16.7,0,0,0-.45-3.86l5.6,5.59,8.84-8.84a16.61,16.61,0,0,0,0-23.49ZM50,30.82a16.6,16.6,0,0,0-8.06-10l-1.47-.8-6.7,6.7L36.92,28a8,8,0,0,1,2.74,13.11l-17.4,17.4A8,8,0,0,1,10.94,47.2l8.57-8.57a16.55,16.55,0,0,0,8.05,10l1.48.8,6.7-6.7-3.2-1.25a8,8,0,0,1-2.75-13.11L47.2,10.94A8,8,0,0,1,58.52,22.26Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-10.svg
// module id = JV+6
// module chunks = 264